import React from 'react';
import { useDragLayer } from 'react-dnd';

function getItemStyles(currentOffset: any) {
  if (!currentOffset) {
    return { display: 'none' } as React.CSSProperties;
  }
  const { x, y } = currentOffset;
  const transform = `translate(${x}px, ${y}px)`;
  return {
    transform,
    WebkitTransform: transform,
  } as React.CSSProperties;
}

const BundleDragLayer: React.FC = () => {
  const { item, isDragging, currentOffset, itemType } = useDragLayer((monitor) => ({
    item: monitor.getItem(),
    itemType: monitor.getItemType(),
    isDragging: monitor.isDragging(),
    currentOffset: monitor.getSourceClientOffset(),
  }));

  if (!isDragging || itemType !== 'BUNDLE') return null;
  if (!item) return null;

  return (
    <div style={{ position: 'fixed', pointerEvents: 'none', zIndex: 9999, left: 0, top: 0 }}>
      <div
        style={{
          ...getItemStyles(currentOffset),
          background: '#4567e5',
          color: '#fff',
          padding: '6px 10px',
          borderRadius: 4,
          fontSize: 12,
          fontWeight: 600,
          boxShadow: '0 4px 12px rgba(0,0,0,0.25)',
          minWidth: 140,
          maxWidth: 240,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          border: '1px solid #3654b5',
        }}
      >
        {item.name || 'Bundle'}
      </div>
    </div>
  );
};

export default BundleDragLayer;
